const PUBLIC_URL_PREFIX = process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}` : "";

export const LOCAL_DRACO_DECODER_PATH = `${PUBLIC_URL_PREFIX}/draco/`.replace(/\/{2,}/g, "/");

export const LOCAL_DRACO_DECODER_ASSETS = [
  `${PUBLIC_URL_PREFIX}/draco/draco_decoder.js`.replace(/\/{2,}/g, "/"),
  `${PUBLIC_URL_PREFIX}/draco/draco_decoder.wasm`.replace(/\/{2,}/g, "/"),
  `${PUBLIC_URL_PREFIX}/draco/draco_wasm_wrapper.js`.replace(/\/{2,}/g, "/"),
];
